module.exports = __webpack_public_path__ + "img/exhb-matcup.3e80ce6c.png";